// In src/pages/DistributionListsPage.js

import React from 'react';
import { Container, Typography } from '@mui/material';
import DistributionListManager from '../components/DistributionListManager';

function DistributionListsPage() {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom sx={{ mb: 3 }}>
        Manage Notification Lists
      </Typography>
      <DistributionListManager />
    </Container>
  );
}

export default DistributionListsPage;